// @flow
import React from 'react';
import injectSheet from 'react-jss';
import classNames from 'classnames';
import _ from 'shared/lib/gettext';
import { getTemplateSettingsSchema } from 'shared/templates/util';
import Modal from '~/app/components/Modal';
import Button from '~/app/ui/Button';
import EditTemplateProp from './EditTemplateProp';
import { S, A, TONES, DARK } from '~/app/ui/tokens';

type Props = {
  classes: Object,
  template: Object,
  onClose: () => void,
  onSave: () => void,
}

class TemplateEditor extends React.Component {
  props: Props = this.props;

  constructor(props) {
    super(props);
    this.state = {
      indexActiveTab: 0,
      // Copy current props into state. Updates will be applied here until the
      // user clicks 'save'.
      props: { ...props.template.props }
    };
  }

  handleChange = (key, val) => {
    const newProps = {
      ...this.state.props,
      [key]: val
    };

    this.setState({ props: newProps });
  }

  handleSave = () => {
    this.props.onSave(this.state.props);
    this.props.onClose();
  }

  renderMenuItem(schema, i) {
    const { classes: c } = this.props;

    return (
      <div
        className={classNames(c.menuItem, {
          'is-active': this.state.indexActiveTab === i
        })}
        key={schema.key}
        onClick={() => this.setState({ indexActiveTab: i })}
      >
        {schema.label}
      </div>
    );
  }

  render() {
    const { classes: c, template, onClose } = this.props;
    const { indexActiveTab } = this.state;
    const templateSettingsSchema = getTemplateSettingsSchema(template.templateId);
    const activeSchema = templateSettingsSchema[indexActiveTab];

    const actions = (
      <div className={c.actions}>
        <Button onClick={onClose}>Cancel</Button>
        <Button variant="primary" onClick={this.handleSave}>Save</Button>
      </div>
    );

    return (
      <Modal
        title={_('EDIT_TEMPLATE_SETTINGS')}
        onClose={onClose}
        actions={actions}
      >
        <div className={c.leftCol}>
          {templateSettingsSchema.map((schema, i) => this.renderMenuItem(schema, i))}
        </div>
        <div className={c.rightCol}>
          {activeSchema ? (
            <EditTemplateProp
              schema={activeSchema}
              value={this.state.props[activeSchema.key]}
              onChange={(key, newVal) => this.handleChange(key, newVal)}
            />
          ) : _('NO_TEMPLATE_SETTINGS')}
        </div>
      </Modal>
    );
  }
}

const styles = {
  container: {

  },
  leftCol: {
    borderRight: '1px solid hsl(0, 0%, 90%)',
    width: '200px',
    minWidth: '200px',
    display: 'flex',
    flexDirection: 'column',
    padding: '0',
    background: 'hsl(220, 0%, 95%)',
    overflowY: 'auto',
    [DARK]: { borderRightColor: S.line, background: S.chrome }
  },
  rightCol: {
    padding: '20px',
    flexGrow: 2,
    display: 'flex',
    flexDirection: 'column',
    overflowY: 'scroll'
  },
  menuItem: {
    color: 'hsl(0, 0%, 30%)',
    cursor: 'pointer',
    padding: '15px 10px',
    textAlign: 'left',
    fontWeight: '300',
    background: 'none',
    '&:hover': {
      background: 'hsl(225, 5%, 90%)',
    },
    '&.is-active': {
      color: 'hsl(200, 41%, 33%)',
      fontWeight: '400',
      background: 'hsl(225, 5%, 90%)',
    },
    [DARK]: {
      color: S.fg,
      '&:hover': { background: S.chromeHover },
      '&.is-active': { color: TONES.blue.fg, background: A.rowSelected }
    }
  },
  actions: {
    display: 'flex',
    width: '100%',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: 8,
    padding: '14px 15px',
    borderTop: '1px solid hsl(0, 0%, 90%)',
    [DARK]: { borderTopColor: S.line }
  },
};

export default injectSheet(styles)(TemplateEditor);
